import { Injectable } from "@angular/core";
import { CompletionBehaviorTemplate } from "../../../entities/completionBehaviorTemplate/completionBehaviorTemplate";
import { ToastService } from "../../toast/toast.service";
import { CompletionBehavior, HasCommands, Reloadable } from "../command.service";

@Injectable({
    providedIn: 'root'
  })
export class ToastCompletionBehavior implements CompletionBehavior {

    constructor(
        private toastService: ToastService
    ) { }

    executeCompletionBehavior(hasCommands: HasCommands, completionBehaviorTemplate: CompletionBehaviorTemplate, reloadable?: Reloadable) {

        const toastMessage = completionBehaviorTemplate?.settings?.toastMessage;

        if(toastMessage){
            this.toastService.addToastWithMessage(toastMessage);
        }

    }

}
